import runLoggedOut from 'actions/lib/run_logged_out';

export default function(context) {
  if (!context.stores.auth.get().isLoggedIn()) {
    runLoggedOut(context);
  }
}
